export const colors = {
  baseGreen: '#00ce00',
  backgroundGreen: '#a5f3a5',
  baseWhite: '#ffffff',
  baseGray: '#f1f1f1',
  baseGray2: '#3f3f3f',
  baseGray3: '#8a8a8a',
  baseGray4: '#cfcfcf',
  baseGray5: '#b9b9b9',
  baseGray6: '#C1C1C1',
  baseBlack: '#000000',
  roseError: '#e768b0',
  orange: '#ff693a',
  yellow: '#FFEC40',
  gray: '#EDEDED',
};
